module.exports = __webpack_public_path__ + "media/images/keyVisual_pc_th-c391032bad5d5b5440df497c037b3f4e.jpg";